import { theme, STUDIO_APP_COLOR } from '../../modules/studio/constants/theme';

const UserProfileStyles = () => ({
  root: {
    position: 'relative',
    backgroundColor: `${STUDIO_APP_COLOR} !important`,
    borderRadius: '12px !important',
    padding: '8px 12px !important',
    '&:hover': {
      backgroundColor: `${STUDIO_APP_COLOR} !important`,
      transform: 'scale(1.05)',
      boxShadow: `0 4px 20px ${theme.colors.background.overlayDark}`,
      textDecoration: 'none'
    },
    '&:hover::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: '12px',
      padding: '2px',
      background: 'linear-gradient(135deg, #E49D2D 0%, #EA0B7E 51.09%, #851B4A 100%)',
      mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      maskComposite: 'exclude'
    }
  },
  header: {
    paddingBottom: 14
  },
  divider: {
    margin: '0px 24px'
  },
  menuItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    paddingTop: 14,
    paddingBottom: 14
  }
});

export default UserProfileStyles;
